import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, normalizeClass as _normalizeClass, vModelText as _vModelText, withDirectives as _withDirectives } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "drawer-wrapper"
};
const _hoisted_2 = { class: "drawer-container" };
const _hoisted_3 = { class: "drawer-header" };
const _hoisted_4 = { class: "d-flex align-items-center justify-content-between w-100" };
const _hoisted_5 = { class: "mb-0 fw-bold" };
const _hoisted_6 = { class: "drawer-body custom-scroll" };
const _hoisted_7 = {
    key: 0,
    class: "text-center py-5"
};
const _hoisted_8 = { key: 1 };
const _hoisted_9 = { class: "summary-card mb-25" };
const _hoisted_10 = { class: "row g-0" };
const _hoisted_11 = { class: "col-6 border-end p-20" };
const _hoisted_12 = { class: "label" };
const _hoisted_13 = { class: "value text-primary" };
const _hoisted_14 = { class: "col-6 p-20 text-end" };
const _hoisted_15 = { class: "value" };
const _hoisted_16 = { class: "table-responsive" };
const _hoisted_17 = { class: "table align-middle custom-table" };
const _hoisted_18 = { class: "text-end" };
const _hoisted_19 = { key: 0 };
const _hoisted_20 = { class: "date-col" };
const _hoisted_21 = { class: "d-flex flex-column" };
const _hoisted_22 = { class: "description" };
const _hoisted_23 = {
    key: 0,
    class: "restaurant-tag"
};
const _hoisted_24 = { class: "text-end fw-bold" };
const _hoisted_25 = { class: "text-end" };
const _hoisted_26 = ["title", "onClick"];
const _hoisted_27 = {
    key: 0,
    class: "pagination-footer"
};
const _hoisted_28 = ["disabled"];
const _hoisted_29 = { class: "page-info" };
const _hoisted_30 = ["disabled"];
const _hoisted_31 = {
    key: 0,
    class: "modal-overlay"
};
const _hoisted_32 = { class: "modal-content-custom" };
const _hoisted_33 = { class: "mb-4" };
const _hoisted_34 = { class: "mb-3" };
const _hoisted_35 = { class: "form-label" };
const _hoisted_36 = { class: "mb-4" };
const _hoisted_37 = { class: "form-label" };
const _hoisted_38 = { class: "d-flex justify-content-end gap-2" };
const _hoisted_39 = ["disabled"];
const _hoisted_40 = {
    key: 1,
    class: "modal-overlay"
};
const _hoisted_41 = { class: "modal-content-custom" };
const _hoisted_42 = { class: "mb-3" };
const _hoisted_43 = { class: "text-muted mb-4" };
const _hoisted_44 = { class: "d-flex justify-content-end gap-2" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_ctx.visible)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("div", {
                class: "drawer-mask",
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('close')))
            }),
            _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", _hoisted_3, [
                    _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("h5", _hoisted_5, [
                            _cache[11] || (_cache[11] = _createElementVNode("i", { class: "flaticon-user text-primary me-2" }, null, -1)),
                            _createTextVNode(" Détails Fidélité : " + _toDisplayString(_ctx.customerName), 1)
                        ]),
                        _createElementVNode("button", {
                            type: "button",
                            class: "btn-close shadow-none",
                            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.$emit('close')))
                        })
                    ])
                ]),
                _createElementVNode("div", _hoisted_6, [
                    (_ctx.loading)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [...(_cache[12] || (_cache[12] = [
                                _createElementVNode("div", {
                                    class: "spinner-border text-primary",
                                    role: "status"
                                }, null, -1),
                                _createElementVNode("p", { class: "mt-2 text-muted" }, "Chargement de l'historique...", -1)
                            ]))]))
                        : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                                _createElementVNode("div", _hoisted_10, [
                                    _createElementVNode("div", _hoisted_11, [
                                        _createElementVNode("span", _hoisted_12, _toDisplayString(_ctx.$t('loyalty.reportBalance') || 'Solde Actuel'), 1),
                                        _createElementVNode("div", _hoisted_13, [
                                            _createTextVNode(_toDisplayString(_ctx.currentBalance) + " ", 1),
                                            _cache[13] || (_cache[13] = _createElementVNode("small", null, "pts", -1))
                                        ]),
                                        _createElementVNode("button", {
                                            class: "btn btn-sm btn-outline-primary mt-2 d-flex align-items-center",
                                            onClick: _cache[2] || (_cache[2] =
                                                //@ts-ignore
                                                (...args) => (_ctx.openAdjustModal && _ctx.openAdjustModal(...args)))
                                        }, [
                                            _cache[14] || (_cache[14] = _createElementVNode("i", { class: "flaticon-edit-1 me-1" }, null, -1)),
                                            _createTextVNode(" " + _toDisplayString(_ctx.$t('loyalty.adjustPoints')), 1)
                                        ])
                                    ]),
                                    _createElementVNode("div", _hoisted_14, [
                                        _cache[16] || (_cache[16] = _createElementVNode("span", { class: "label" }, "Total Cumulé", -1)),
                                        _createElementVNode("div", _hoisted_15, [
                                            _createTextVNode(_toDisplayString(_ctx.totalEarned) + " ", 1),
                                            _cache[15] || (_cache[15] = _createElementVNode("small", null, "pts", -1))
                                        ])
                                    ])
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("table", _hoisted_17, [
                                    _createElementVNode("thead", null, [
                                        _createElementVNode("tr", null, [
                                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('loyalty.reportDate') || _ctx.$t('common.date')), 1),
                                            _createElementVNode("th", null, _toDisplayString(_ctx.$t('loyalty.reportAction')), 1),
                                            _createElementVNode("th", _hoisted_18, _toDisplayString(_ctx.$t('loyalty.reportPoints')), 1),
                                            _cache[17] || (_cache[17] = _createElementVNode("th", {
                                                class: "text-end",
                                                style: { "width": "50px" }
                                            }, null, -1))
                                        ])
                                    ]),
                                    _createElementVNode("tbody", null, [
                                        (_ctx.transactions.length === 0)
                                            ? (_openBlock(), _createElementBlock("tr", _hoisted_19, [...(_cache[18] || (_cache[18] = [
                                                    _createElementVNode("td", {
                                                        colspan: "4",
                                                        class: "text-center py-5 text-muted italic"
                                                    }, " Aucune transaction trouvée. ", -1)
                                                ]))]))
                                            : _createCommentVNode("", true),
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (tx) => {
                                            return (_openBlock(), _createElementBlock("tr", {
                                                key: tx.id
                                            }, [
                                                _createElementVNode("td", _hoisted_20, _toDisplayString(_ctx.formatDate(tx.createdAt)), 1),
                                                _createElementVNode("td", null, [
                                                    _createElementVNode("div", _hoisted_21, [
                                                        _createElementVNode("span", {
                                                            class: _normalizeClass(["badge-type", tx.type.toLowerCase()])
                                                        }, _toDisplayString(_ctx.$t(`loyalty.${tx.type.toLowerCase()}`)), 3),
                                                        _createElementVNode("span", _hoisted_22, _toDisplayString(tx.description), 1),
                                                        (tx.restaurantName)
                                                            ? (_openBlock(), _createElementBlock("span", _hoisted_23, [
                                                                _cache[19] || (_cache[19] = _createElementVNode("i", { class: "flaticon-placeholder-3" }, null, -1)),
                                                                _createTextVNode(" " + _toDisplayString(tx.restaurantName), 1)
                                                            ]))
                                                            : _createCommentVNode("", true)
                                                    ])
                                                ]),
                                                _createElementVNode("td", _hoisted_24, [
                                                    _createElementVNode("span", {
                                                        class: _normalizeClass(tx.amount >= 0 ? 'text-success' : 'text-danger')
                                                    }, _toDisplayString(tx.amount >= 0 ? '+' : '') + _toDisplayString(tx.amount), 3)
                                                ]),
                                                _createElementVNode("td", _hoisted_25, [
                                                    (_ctx.canReverse(tx))
                                                        ? (_openBlock(), _createElementBlock("button", {
                                                            key: 0,
                                                            class: "btn-action-icon",
                                                            title: _ctx.$t('loyalty.reverseTransaction'),
                                                            onClick: ($event) => (_ctx.confirmReverse(tx))
                                                        }, [...(_cache[20] || (_cache[20] = [
                                                                _createElementVNode("i", { class: "flaticon-back" }, null, -1)
                                                            ]))], 8, _hoisted_26))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]));
                                        }), 128))
                                    ])
                                ])
                            ]),
                            (_ctx.pagination.totalPages > 1)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                                    _createElementVNode("button", {
                                        class: "nav-btn",
                                        disabled: _ctx.pagination.page === 1,
                                        onClick: _cache[3] || (_cache[3] = ($event) => (_ctx.fetchData(_ctx.pagination.page - 1)))
                                    }, [...(_cache[21] || (_cache[21] = [
                                            _createElementVNode("i", { class: "flaticon-chevron-1" }, null, -1),
                                            _createTextVNode(" Précédent ", -1)
                                        ]))], 8, _hoisted_28),
                                    _createElementVNode("div", _hoisted_29, [
                                        _cache[22] || (_cache[22] = _createTextVNode(" Page ", -1)),
                                        _createElementVNode("strong", null, _toDisplayString(_ctx.pagination.page), 1),
                                        _createTextVNode(" / " + _toDisplayString(_ctx.pagination.totalPages), 1)
                                    ]),
                                    _createElementVNode("button", {
                                        class: "nav-btn",
                                        disabled: _ctx.pagination.page === _ctx.pagination.totalPages,
                                        onClick: _cache[4] || (_cache[4] = ($event) => (_ctx.fetchData(_ctx.pagination.page + 1)))
                                    }, [...(_cache[23] || (_cache[23] = [
                                            _createTextVNode(" Suivant ", -1),
                                            _createElementVNode("i", { class: "flaticon-chevron" }, null, -1)
                                        ]))], 8, _hoisted_30)
                                ]))
                                : _createCommentVNode("", true)
                        ]))
                ])
            ]),
            (_ctx.showAdjustModal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                        _createElementVNode("h5", _hoisted_33, _toDisplayString(_ctx.$t('loyalty.adjustPoints')), 1),
                        _createElementVNode("div", _hoisted_34, [
                            _createElementVNode("label", _hoisted_35, _toDisplayString(_ctx.$t('loyalty.amount')) + " (ex: 50 ou -50)", 1),
                            _withDirectives(_createElementVNode("input", {
                                type: "number",
                                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event) => ((_ctx.adjustForm.amount) = $event)),
                                class: "form-control"
                            }, null, 512), [
                                [
                                    _vModelText,
                                    _ctx.adjustForm.amount,
                                    void 0,
                                    { number: true }
                                ]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_36, [
                            _createElementVNode("label", _hoisted_37, _toDisplayString(_ctx.$t('loyalty.reason')), 1),
                            _withDirectives(_createElementVNode("textarea", {
                                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event) => ((_ctx.adjustForm.reason) = $event)),
                                class: "form-control",
                                rows: "3"
                            }, null, 512), [
                                [_vModelText, _ctx.adjustForm.reason]
                            ])
                        ]),
                        _createElementVNode("div", _hoisted_38, [
                            _createElementVNode("button", {
                                class: "btn btn-light",
                                onClick: _cache[7] || (_cache[7] = ($event) => (_ctx.showAdjustModal = false))
                            }, "Annuler"),
                            _createElementVNode("button", {
                                class: "btn btn-primary",
                                disabled: !_ctx.adjustForm.amount || !_ctx.adjustForm.reason,
                                onClick: _cache[8] || (_cache[8] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleAdjust && _ctx.handleAdjust(...args)))
                            }, " Confirmer ", 8, _hoisted_39)
                        ])
                    ])
                ]))
                : _createCommentVNode("", true),
            (_ctx.showReverseModal)
                ? (_openBlock(), _createElementBlock("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                        _createElementVNode("h5", _hoisted_42, _toDisplayString(_ctx.$t('loyalty.reverseTransaction')), 1),
                        _createElementVNode("p", _hoisted_43, _toDisplayString(_ctx.$t('loyalty.confirmReverse')), 1),
                        _createElementVNode("div", _hoisted_44, [
                            _createElementVNode("button", {
                                class: "btn btn-light",
                                onClick: _cache[9] || (_cache[9] = ($event) => (_ctx.showReverseModal = false))
                            }, "Annuler"),
                            _createElementVNode("button", {
                                class: "btn btn-danger",
                                onClick: _cache[10] || (_cache[10] =
                                    //@ts-ignore
                                    (...args) => (_ctx.handleReverse && _ctx.handleReverse(...args)))
                            }, "Confirmer")
                        ])
                    ])
                ]))
                : _createCommentVNode("", true)
        ]))
        : _createCommentVNode("", true);
}
